export const UPDATE_INGREDIENT_KEYWORD_DETAILS = {
  START: 'START_UPDATE_INGREDIENT_KEYWORD_DETAILS',
  COMPLETE: 'COMPLETE_UPDATE_INGREDIENT_KEYWORD_DETAILS',
  FAIL: 'FAIL_UPDATE_INGREDIENT_KEYWORD_DETAILS',
}

export const CLEAR_MAIN_KEYWORD_ERROR = 'CLEAR_MAIN_KEYWORD_ERROR'

export const ADD_KEYWORD = 'ADD_KEYWORD'
export const RENAME_KEYWORD = 'RENAME_KEYWORD'
export const DELETE_KEYWORD = 'DELETE_KEYWORD'
export const RESET_INGREDIENT_KEYWORDS = 'RESET_INGREDIENT_KEYWORDS'
export const SET_DATA_FOR_RENAMING_KEYWORD = 'SET_DATA_FOR_RENAMING_KEYWORD'

export const CHECK_MAIN_KEYWORD_NODES_FOR_TYPE =
  'CHECK_MAIN_KEYWORD_NODES_FOR_TYPE'

export const CHANGE_CHECKED_KEYWORDS_LANGUAGE =
  'CHANGE_CHECKED_KEYWORDS_LANGUAGE'

export const DELETE_CHECKED_KEYWORDS = 'DELETE_CHECKED_KEYWORDS'
